/**
 * DraggableMenu
 * v1.2 拖拽是不触发点击事件
 */

import * as React from "react";
import { useState } from "react";
import { Button } from "antd";
import { motion } from "framer-motion";
// import { useDragControls } from "framer-motion";

import { IconMenu } from "@/components/Icon";
import { useWindowSize } from "react-use";
import DrawerAntd from "@/components/menu/DrawerAntd";

export const DraggableMenu = () => {
  const dragArea = React.useRef();   const { height, width } = useWindowSize()  // 获取窗口inner宽高
  const [isDragging, setIsDragging] = useState(false); // 是否不为拖动

  React.useEffect(()=>{
  },[])

  const [open, setOpen] = useState(false);
  const onClose = () => {setOpen(false)};
  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0,
        // background:'red',
        width: width, height: height, zIndex: -1000000
      }} ref={dragArea}>
      </div>

      <motion.div
        drag
        // dragControls={controls}
        // style={
        //   {zIndex: 1000000000}
        // }
        initial={{
          position: 'fixed',
          left: '47%',
          bottom: 20,
          zIndex: 1000000,
          opacity: 1
        }}
        animate={{ opacity: 0.5 }}
        dragConstraints={dragArea}
        dragElastic={{  // 回弹效果0为最小，1为最大，默认0.5
        left: 0,
          top: 0.,
          bottom: 0,
          right: 0
        }}
        whileHover={{ opacity: 1 }}
        transition={{
          delay: 0.3,
        }}
        whileDrag={(_,info)=>{setIsDragging(true)}}  // 拖动开始(拖动的时候调用一次)
        onDragEnd={(_,info)=>{setIsDragging(false)}} // 拖动结束(拖动结束的时候调用一次)
        onClick={() => { if(!isDragging){setOpen(!open)} }}  // 如果不是拖动则是点击事件

      >
        <Button
          style={{ padding: 0 }}
          icon={<IconMenu style={{ fontSize: 30, width: 30, height: 30, padding: 0 }} />}
        />
      </motion.div>
      <DrawerAntd 
        open={open} 
        onClose={onClose} 
        forceRender={true}  // 预加载
        placement={'bottom'}
        height={260}
      />
    </>
  );
};

export default DraggableMenu


